<template>
  <div class="zon">
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div class="by" v-if="!loading">
      <div class="new-div-by"></div>
      <div class="div-cont">
        <div class="plan2">
          <div class="div-qu">
            <div class="qu" v-for="(item, index) in list" :key="index">
              <van-panel>
                <template #header>
                  <div class="van-cell">
                    <img width="20" height="20" :src="showImg" alt />
                    <span class="te">{{item.branchName}}</span>
                  </div>
                </template>
                <template #footer>
                  <div class="order_btn mr-5">
                    <span class="col9">共{{item.branchGoodsTotalCount}}件商品，共计</span>
                    <span class="red">￥{{item.branchGoodsTotalAmount}}</span>
                  </div>
                </template>
                <div class="order_item" v-for="(t,idx) in item.orderSkuList" :key="idx">
                  <div class="order_info">
                    <div class="img">
                      <van-image :src="t.skuIcon" width="70" height="70" fit="cover" />
                    </div>
                    <div class="info">
                      <div class="infop1">
                        <strong>{{t.goodsName}}</strong>
                        <div>
                          <p class="col9">￥{{t.skuPrice}}</p>
                        </div>
                      </div>
                      <div class="infop1 mr-10">
                        <div class="si col9">{{t.specStr}}</div>
                        <div class="si col9">x{{t.skuNum}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="order_btn_left">
                    <div class='active_type_vertiu'>虚拟商品</div>
                    <div class="rrg">￥ {{chckObj.totalGoodsPrice}}</div>
                  </div>
                </div>
                <div class="fott2"></div>
              </van-panel>
            </div>
          </div>
        </div>
        
        <div class="plan">
          <van-cell-group class="ta">
            <van-cell title="商品金额" :value="'￥'+chckObj.totalGoodsPrice" />
          </van-cell-group>
        </div>
        <div class="ofr">
          <van-submit-bar
            :price="chckObj.actualPrice *100"
            button-text="提交订单"
            @submit="checkFun"
            :loading="checkLoading"
          />
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import http from '@/utils/axios'
import utils from '@/utils/common'
import couponItemA from '@/views/me/components/couponItemA'
import couponItemB from '@/views/me/components/couponItemB'
import preferDetail from '@/components/coupon/prefer-detail'
import sureAddress from '@/views/me/components/surAddress'
import { Toast } from 'vant'

export default {
  data() {
    return {
      seckillSkuId: this.$route.query.seckillSkuId ? this.$route.query.seckillSkuId : '',
      shoppingCartParams: [],
      show:false,
      userAvailableCouponList: [],
      userUnavailableCouponList: [],
      checkLoading: false,
      goodsList: [],
      userCouponId: '',
      defaultUserCouponId: '',
      loading: false,
      receiverAddressInfo: {
        addressDetail: '',
        areaId: '',
        areaName: '',
        cityId: '',
        id: '',
        isDefault: '',
        mobile: '',
        provinceId: '',
        userId: '',
        userName: ''
      },
      list: [],
      chckObj: {
        totalFrightPrice: '',
        totalGoodsPrice: '',
        actualPrice: '',
        couponDiscountPrice:'',
        frightCouponValue: '',
        freeShippingType:'',
        totalDiscount: '',
        totalPrice: '',
        branchDiscount: '',
        hasNotAllowedSaleAfter: ''
      },
      couponCancel:0, //标记优惠券是初次加载还是认为取消选中 0 初次加载 1 人为取消
      frightCouponCancel:0, //标记运费券是初次加载还是认为取消选中 0 初次加载 1 人为取消
      frightCouponBranchChooseDtoList:[],
      userFrightCouponId:[],
      showImg: require("@/assets/image/brand.png"),
    }
  },
  methods: {
    onGetAddressDetail () {
      http({
        url: '/base/user/address/findDefault',
        method: 'post',
        parmes: {}
      })
      .then(rps => {
        if (rps.code == 200 && rps.data) {
          this.receiverAddressInfo = rps.data;
        } else {
          this.receiverAddressInfo = {
            addressDetail: '未添加收货地址信息'
          }
        }
        this.init('render');
      }).catch(err => {
        this.receiverAddressInfo = {
          addressDetail: '未添加收货地址信息'
        }
      })
    },
    checkFun() {
      let params = {
        deliveryType: 'EXPRESS',
        isAgree: 'n',
        address: this.receiverAddressInfo.addressDetail,
        mobile: this.receiverAddressInfo.mobile,
        userName: this.receiverAddressInfo.userName,
        addressId: this.receiverAddressInfo.id,
        actualPrice: this.chckObj.actualPrice,
        userCouponId: this.userCouponId,
        userFrightCouponId:this.userFrightCouponId,
        frightCouponBranchChooseDtoList:this.frightCouponBranchChooseDtoList
      }
      //console.log(params);
      this.checkLoading = true
      if (!this.$route.query.id) {
          (params.goodId = this.$route.query.goodsId),
          (params.skuId = this.$route.query.skuId),
          (params.count = this.$route.query.count),
          (params.seckillSkuId = this.$route.query.seckillSkuId),
          (params.remark = '')
        http({
          url: 'order/app/create/byNow',
          method: 'post',
          parmes: params
        })
          .then(rps => {
            this.checkLoading = false
            if (window.isApp == 'IOS') {
              window.webkit.messageHandlers.pushPaymentViewController.postMessage(
                { orderId: rps.data }
              )
            } else {
              console.log('callPay=>', rps.data)
              window.beego.callPay(rps.data)
            }
          })
          .catch(res => {
            this.checkLoading = false
            if (res.code == 500) {
              this.init();
              return false
            }
          })
      } else {
        params.cartList = this.$route.query.id.split(',');
        params.shoppingCartParams = this.shoppingCartParams;
        params.subOrderRemark = [];
        http({
          url: 'order/app/create',
          method: 'post',
          parmes: params
        })
          .then(rps => {
            this.checkLoading = false
            if (window.isApp == 'IOS') {
              window.webkit.messageHandlers.pushPaymentViewController.postMessage(
                {
                  orderId: rps.data
                }
              )
            } else {
              window.beego.callPay(rps.data)
            }
          })
          .catch(res => {
            this.checkLoading = false
            if (res.code == 500) {
              this.init()
              return false
            }
          })
      }
    },
    destroyed () {
      localStorage.removeItem('chosenAddressId');
      sessionStorage.removeItem('submitRouter');
    },
    init(flag) {
      this.loading = true;
      if (this.$route.query.token) {
        sessionStorage.setItem('token', this.$route.query.token)
      }
      http({
        url: 'order/app/settle',
        method: 'post',
        parmes: {
          couponCancel: this.couponCancel,
          frightCouponCancel: this.frightCouponCancel,
          frightCouponBranchChooseDtoList: this.frightCouponBranchChooseDtoList,
          userFrightCouponId: this.userFrightCouponId,
          goodsId: this.$route.query.goodsId || '',
          shopCartIdList: this.$route.query.id && this.$route.query.id.split(',') || [],
          skuId: this.$route.query.skuId || '',
          count: this.$route.query.count || '',
          userAddressId: localStorage.getItem('chosenAddressId') || this.receiverAddressInfo.id || '',
          userCouponId: this.userCouponId || ''
        }
      })
        .then(res => {
          this.loading = false
          this.goodsList=[]
          this.shoppingCartParams =[]
          this.frightCouponBranchChooseDtoList=[]
          this.userFrightCouponId=[]
          if (res.data.receiverAddressInfo) {
            this.receiverAddressInfo = res.data.receiverAddressInfo
          }
          //为每个店铺的留言准备数据
          res.data.branchList.forEach(element => {
            element.remark = ''

            //为优惠券接口准备参数
            element.orderSkuList.forEach(itm => {
              this.goodsList.push({
                count: itm.skuNum,
                discountPrice: '',
                goodsId: itm.spuId,
                skuId: itm.skuId,
                totalPrice: itm.discountPrice,
                branchno: itm.branchId
              })

              if (this.$route.query.id) {
                // 秒杀类型
                let shoppingCartParams = { cartId: itm.shopCartId }
                if (itm.seckillType == 1) {
                  shoppingCartParams.seckillSkuId = itm.seckillSkuId
                }
                this.shoppingCartParams.push(shoppingCartParams)
              }
            })

            //运费券显示
            if(element.userAvailableFrightCouponList && element.userAvailableFrightCouponList.length > 0){
              element.defaultFrightCoupon = {}
              element.userAvailableFrightCouponList.forEach(ele => {
                ele.branchId = element.branchId
                ele.frightPrice = element.frightPrice
                if(ele.chooseStatus == 1){
                  element.defaultFrightCoupon = {
                    couponValueFormat: + ele.couponValue,
                    userFrightCouponId: ele.userCouponId,
                    couponId: ele.couponId,
                    branchId: element.branchId,
                    frightPrice: element.frightPrice,
                    branchName: element.branchName,
                    acliyFriPrice: element.frightPrice <= ele.couponValue ? element.frightPrice : ele.couponValue
                  }
                  this.frightCouponBranchChooseDtoList.push(element.defaultFrightCoupon)
                  this.userFrightCouponId.push(element.defaultFrightCoupon.userFrightCouponId)
                }
              });
            }else{
              element.defaultFrightCoupon = {
                couponValue: '无可用',
                userFrightCouponId: -1,
                couponId : -1
              }
            }
          })
          this.list = res.data.branchList

          //确认钱render
          for (const key in this.chckObj) {
            this.chckObj[key] = res.data[key]
          }
        })
        .catch((res) => {
          this.loading = false
          this.checkLoading = true
          if(res.code == '32311'){
            this.$toast.clear();
            this.receiverAddressInfo.addressDetail='未添加收货地址信息';
            this.$toast('请添加收货地址');
          }
        })
    },
  },
  created() {
    this.$loading.hide();
    this.onGetAddressDetail();
    utils.nativeMethod({tm:'4000102',tp:{pageType_pvar:'确认订单'}})
    utils.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
  },
  watch: {},
  components: { couponItemA,couponItemB,sureAddress,preferDetail }
}
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.zon {
  position: relative;
  font-size: 0.35rem;
  background-color: #f7f7f7;
  .new-div-by {
    height: 124px;
    width: 100%;
    background-color: #f8d541;
  }
}
.div-cont {
  width: 90%;
  margin-top: -86px;
  margin-left: 5%;
  margin-bottom: 120px;
  .yu {
    border-radius: 20px;
  }
}
.plan {
  background: #fff;
  border-radius: 0.24rem;
  padding: 0.4rem 0;
  margin-bottom: 20px;
  .van-row {
    height: 1.2rem;
    line-height: 1.2rem;
    border-bottom: 0.01rem solid rgba(225, 225, 225, 1);
  }
}
.red2 {
  .van-cell__value {
    position: relative;
    overflow: hidden;
    color: #ed3939;
    text-align: right;
    vertical-align: middle;
    word-wrap: break-word;
  }
}
.plan3 {
  height: 93px;
  line-height: 93px;
  margin-bottom: 20px;
  
}
/deep/.van-cell-group {
  border-radius:10px;
}
.plan-a {
  display: flex;
  justify-content: flex-start;
  margin-left: 0, 4rem;
  .plan-a-1 {
    padding-left: 20px;
    margin-right: 20px;
    vertical-align: auto;
    line-height: 0.5rem;
    .img {
      width: 40PX;
      height: 40PX;
    }
  }
  .reg {
    padding-top: 0.35rem;
  }
  .plan-a-2 {
    flex: 1;
    padding-top: 0.2rem;
    line-height: 0.5rem;
  }
}
.plan2 {
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  .div-qu {
    font-size: 0.4rem;
    text-align: left;
    border-radius:10px;
    /deep/.van-panel__footer {
      padding: 0 0;
      padding-bottom: 25px;
      border-radius:10px;
    }
    .fott1{
      border-top: 1PX solid #F2F2F2;
    }
    .fott2{
      border-top: 1PX solid #F2F2F2;
      margin-left: 30px;
      margin-right: 30px;
      margin-top: 15px;
    }
  }
  .qu {
    margin-bottom: 20px;
    border-radius:10px;
    /deep/.van-field__right-icon {
      color: #cccccc;
    }
  }
  .order_item {
    padding: 10px 30px;
    .footer_goodinfo {
      text-align: right;
      font-size: 26px;
    }
    .order_info {
      margin-top: 20px;
      display: flex;
      .info {
        flex: 1;
        .infop1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 26px;
          span {
            color: #999;
          }
          strong {
            color: #333;
            max-height: 74px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .si {
            font-size: 24px;
            margin-top: 29px;
          }
        }
        .attr {
          color: #999999;
          font-size: 24px;
          padding: 10px 0;
        }
      }

      .img {
        position: relative;
        width: 140px;
        height: 140px;
        margin-right: 15px;
        span {
          position: absolute;
          left: 0;
          top: 0;
          width: 60px;
          height: 30px;
          line-height: 30px;
          color: white;
          font-size: 22px;
          background-color: #fa6400;
          border-radius: 0 0 10px 0;
          text-align: center;
        }
      }
    }
    .xg {
      color: #f8a651;
      font-size: 22px;
      margin-left: 30px;
      margin-top: 15px;
    }
    .xr{
      text-align: right;
      font-size: 26px;
      margin-top: 30px;
    }
    .fot {
      text-align: right;
    }
    .order_info_img {
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
    }
  }
  .order_btn {
    font-size: 26px;
    text-align: right;
    padding: 5px 20px;
  }
  .order_btn_left {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .active_type_vertiu{
      background-color: #FD9090;
      font-size: 20px;
      color: #fff;
      border-radius: 10px;
      padding: 4px 30px;
    }
    .rrg{
      font-size: 26px;
      color: #999999;
      text-align: center;
    }
  }
}
.col9 {
  color: #999;
}
.red {
  color: #ed3939;
}
[class*='van-hairline']::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  top: -50%;
  right: -50%;
  bottom: -50%;
  left: -50%;
  border: 0;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
}
.int {
  /deep/.van-field__control {
    border:1PX solid rgba(242,242,242,1);
    text-align: left;
    font-size: 24px;
    padding-left: 30px;
    background-color: #ffffff;
    -webkit-appearance: none;
  }
  input{
    -webkit-appearance: none;
  }
}
.van-cell {
  border-radius: 10px;
}
.van-cell:not(:last-child)::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0.4244rem;
  border-bottom: 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.ta {
  position: relative;
  .tag {
    z-index: 1;
    position: absolute;
    margin-top: 22px;
    margin-left: 150px;
    border-radius: 10px;
    border: 1PX solid rgba(248, 166, 81, 1);
    color: #f8a651;
    font-size: 20px;
    text-align: center;
    height: 33px;
    line-height: 33px;
  }
  .tag2 {
    z-index: 1;
    position: absolute;
    margin-top: 30px;
    margin-left: 120px;
    height: 28px;
    text-align: center;
    line-height: 28px;
  }
  .tip{
    width: 410px;
    height: 28px;
    font-size: 20px;
    color: #999999;
    line-height: 28px;
    position:absolute;
    z-index: 1;
    top:0;
    left: 0;
    padding-left: 30px;
    margin-top: 60px;
  }
}
.ofr {
  .van-submit-bar__text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    padding-right: 0.3183rem;
    color: #323233;
    text-align: left;
  }
  .van-submit-bar__button {
    width: 160px;
    height: 60px;
    line-height: 60px;
    background: rgba(248, 213, 65, 1);
    border-radius: 32px;
    font-size: 24px;
  }
  .van-button--danger {
    color: #333;
  }
}
/deep/.van-tabs__line {
  background-color: rgb(248, 213, 65);
}
.plan-a-2-1 {
  color: #999999;
  font-size: 24px;
}
.img {
  width: 80px;
  height: 80px;
}
.ced {
  position: relative;
}
.icon {
  vertical-align: sub;
  margin-left: 5px;
}
.br.van-cell {
  .van-cell__label {
    white-space: nowrap;
    color: #F8A651;
  }
}
.index-index-brfr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  padding-top: 23px;
}
.index-index-brfr .tt {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.index-index-brfr .tt .tl {
  width: 61px;
  height: 34px;
  color:  #f8a651;
  border: 2px solid #f8a651;
  border-radius: 6px;
  line-height: 34px;
  box-sizing: border-box;
  font-weight: 500;
  text-align: center;
}
.index-index-brfr .tt .dc {
  margin-left: 14px;
}
.index-index-brfr .pr {
  color: #ED3939;
}
.dy { 
  color:  #f8a651;
  font-size: 20px;
  padding-top: 0;
  line-height: 28px;
}
</style>